import { useWorkspaceId } from "../../hooks/useWorkspaceId";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "@tanstack/react-store";
import { useTranslation } from "react-i18next";
import { store } from "../../../store/store";
import type { FulfilmentsDto } from "../use-get-fulfilments/FulfilmentsDto";
import { getQueryStringFromParams } from "../utils/paramUtils";
import { useHttpTaxManagerAppHeaders } from "../utils/useHttpTaxManagerAppHeaders";
import { BASE_API_URL, HttpError } from "../utils/useTaxManagerAppQueryClient";

export function useGetLinkableFulfilments(custom: boolean) {
    const { t } = useTranslation();
    const workspaceId = useWorkspaceId();
    const headers = useHttpTaxManagerAppHeaders();

    const filters = useSelector(
        store,
        (state) => state.fulfilmentSearchFilters,
    );

    const fulfilmentName = filters.fulfilmentName
        ?.trim()
        .replaceAll(/\s{2,}/g, " ");

    const queryParams = {
        ...(custom ? { custom } : {}),
        deadlineFrom: filters.deadlineFrom.getTime(),
        deadlineTo: filters.deadlineTo.getTime(),
        ...(fulfilmentName ? { fulfilmentName } : {}),
    };

    const query = useQuery<FulfilmentsDto>({
        queryKey: ["useGetLinkableFulfilments", workspaceId, queryParams],
        queryFn: async () => {
            const queryString = getQueryStringFromParams(queryParams);
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/linkable-fulfilments?${queryString}`,
                { headers },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return response.json();
        },
        enabled: !!workspaceId,
        meta: {
            resourceName: t("errors.resourceName.linkableFulfilments"),
        },
    });

    return query;
}
